const REASONS_ZERO_RECOVERS_FROM_BY_RELOADING = new Set([
  "Client has been purged due to inactivity",
  "Client not found",
]);
const OLDER_REPLICA_REASON_PREFIX = "Cannot sync from older replica:";
const MUTATION_ID_MISMATCH_REASON =
  /^Client .+ sent mutation ID \d+ but expected \d+$/;

export function connectionErrorFingerprint(
  reason: string
): string[] | undefined {
  if (REASONS_ZERO_RECOVERS_FROM_BY_RELOADING.has(reason)) {
    return;
  }
  if (reason.startsWith(OLDER_REPLICA_REASON_PREFIX)) {
    return ["zero-connection-error", "older-replica"];
  }
  if (MUTATION_ID_MISMATCH_REASON.test(reason)) {
    return ["zero-connection-error", "mutation-id-mismatch"];
  }
  return ["zero-connection-error", reason];
}
